import React from 'react';

import { Heading, HeadingSize } from '@user-interviews/ui-design-system';

type DeviceRequirementsDetailsProps = {
  deviceRequirements: number[];
  deviceSentence: string;
};

export function DeviceRequirementsDetails({
  deviceRequirements,
  deviceSentence,
}: DeviceRequirementsDetailsProps) {
  if (!deviceRequirements.length) return null;

  const formattedDeviceSentence = (deviceSentence.match(/[^.]+./gi) || []).map(
    (elem) => <div key={`${elem}`}>{elem}</div>,
  );

  return (
    <dl>
      <dt>
        <Heading level={2} size={HeadingSize.MEDIUM}>
          Device requirements
        </Heading>
      </dt>
      <dd>{formattedDeviceSentence}</dd>
    </dl>
  );
}
